type Props = {
  color?: string
}

export function RulerSizeIcon({ color = 'black' }: Props) {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4560_9593)">
        <path
          d="M1.34026 9.58399C0.965258 9.58399 0.648259 9.45399 0.389259 9.19499C0.262919 9.07144 0.163225 8.92332 0.0963222 8.75976C0.0294197 8.5962 -0.00327341 8.42067 0.000258503 8.24399V1.75699C0.000258503 1.38199 0.130259 1.06499 0.389259 0.805992C0.648259 0.545992 0.965258 0.416992 1.33926 0.416992H13.8273C14.2023 0.416992 14.5193 0.546992 14.7783 0.805992C15.0383 1.06499 15.1673 1.38199 15.1673 1.75599V8.24399C15.1673 8.61899 15.0373 8.93599 14.7783 9.19499C14.6547 9.32133 14.5066 9.42103 14.343 9.48793C14.1795 9.55483 14.0039 9.58752 13.8273 9.58399H1.34026ZM1.34026 8.49999H13.8273C13.8605 8.49929 13.8932 8.49184 13.9235 8.47809C13.9537 8.46433 13.9809 8.44457 14.0033 8.41999C14.0278 8.39762 14.0476 8.37047 14.0614 8.34022C14.0751 8.30996 14.0826 8.27722 14.0833 8.24399V1.75699C14.0827 1.72359 14.0753 1.69066 14.0615 1.66023C14.0478 1.62979 14.028 1.60248 14.0033 1.57999C13.9809 1.55542 13.9537 1.53565 13.9235 1.5219C13.8932 1.50814 13.8605 1.50069 13.8273 1.49999H11.3753V4.67999H10.2923V1.49999H8.12526V4.67999H7.04226V1.49999H4.87526V4.67999H3.79226V1.49999H1.34026C1.30686 1.50056 1.27393 1.50794 1.24349 1.5217C1.21305 1.53546 1.18575 1.5553 1.16326 1.57999C1.13856 1.60248 1.11873 1.62979 1.10497 1.66023C1.09121 1.69066 1.08382 1.72359 1.08326 1.75699V8.24399C1.08326 8.30799 1.11026 8.36699 1.16326 8.41999C1.21726 8.47399 1.27626 8.49999 1.34026 8.49999Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_4560_9593">
          <rect width="16" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
